import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  constructor(private http: HttpClient) { }

       getAll = () => {
        return this.http.get(environment.userApiUrl + 'api/admin/maintenence',)
         }
          addData = (data: any) => {
          return this.http.post(environment.userApiUrl + 'api/admin/maintenence', data)
        }
         updateData = (data: any) => {
          return this.http.put(environment.userApiUrl + 'api/admin/maintenence', data)
        }
         delete = (data: any) => {
          return this.http.delete(environment.userApiUrl + 'api/admin/maintenence',{ body: data })
        }

}